import { render } from "./SaveDependent.vue?vue&type=template&id=c275d9ea"
import script from "./SaveDependent.vue?vue&type=script&lang=js"
export * from "./SaveDependent.vue?vue&type=script&lang=js"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__